import { apiClient } from "~/lib/utils/axios";
import {
  GetTransactionsParams,
  MesraTransactionItem,
} from "~/lib/types/loyalty.type";
import { GetOneTransaction } from "~/lib/types/variables.type";

export const getLoyaltyHistory = (params?: GetTransactionsParams) => {
  return apiClient
    .get(
      `/loyalty/cards/transactions?limit=${
        params?.perPage || 20
      }&statuses=successful&statuses=pending&statuses=failed&types=earn&types=redeem&types=externalEarn&types=externalRedeem&types=redeemCapture&types=redeemReversal&types=redeemVoid&types=adjustment${
        params?.nextToken ? `&nextToken=${params.nextToken}` : ""
      }`
    )
    .then((response) => {
      let loyaltyHistoryData: MesraTransactionItem[] = response.data.data;

      if (params?.referenceType) {
        loyaltyHistoryData = loyaltyHistoryData.filter(
          (mesra) => mesra.referenceType === params?.referenceType
        );
      }
      if (params?.from) {
        loyaltyHistoryData = loyaltyHistoryData.filter(
          (mesra) =>
            params?.from && new Date(mesra.createdAt) >= new Date(params?.from)
        );
      }
      const loyaltyHistories = {
        data: loyaltyHistoryData,
        nextToken: response.data.nextToken,
      };
      return loyaltyHistories;
    });
};

export const getOneLoyaltyHistory = (params?: GetOneTransaction) => {
  return apiClient
    .get(`loyalty/transactions/${params?.id}`)
    .then((response) => response.data);
};

export const getCardByUserId = (userId?: string) => {
  return apiClient
    .get(`loyalty/system/cards/${userId}`)
    .then((response) => response.data);
};
